import { render, staticRenderFns } from "./PromotionFreeItemChoices.vue?vue&type=template&id=e9a49802&scoped=true&"
import script from "./PromotionFreeItemChoices.vue?vue&type=script&lang=js&"
export * from "./PromotionFreeItemChoices.vue?vue&type=script&lang=js&"
import style0 from "./PromotionFreeItemChoices.vue?vue&type=style&index=0&id=e9a49802&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a49802",
  null
  
)

export default component.exports